module.exports = __webpack_public_path__ + "static/media/exceed14project2.59b81556.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/exceed14project2.png
// module id = 850
// module chunks = 0